
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  display: inline-block;
  overflow: hidden;
  border-radius: 0.5rem;
  font-size: var(--fs-xs);
  line-height: var(--lh-xs);
  font-weight: var(--fw-bold);
  text-transform: uppercase;
}@media (min-width: 1280px) {:host {
    font-size: var(--fs-xxs);
    line-height: var(--lh-xxs);
  }
}@media (min-width: 1440px) {:host {
    font-size: var(--fs-xs);
    line-height: var(--lh-xs);
  }
}:host{
  letter-spacing:0.08em;
}

:host([tag-background='blue']) {
  background-color: var(--blue-responsible-lighten-6);
  color: var(--neutral-black);
}

.image-tag {
  display: inline-block;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  color: var(--neutral-white);
}
`;